import { Component, EventEmitter, Input, Output } from '@angular/core';
import { headerData } from './header-menu';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { HeaderService } from './header.service';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { CommonModule } from '@angular/common';
import { KENDO_ICONS } from '@progress/kendo-angular-icons';

declare var analyticsDataLayer: any;

interface Link {
  url: string;
  class: string;
  linkName: string;
}


@Component({
  selector: 'app-header',
  imports: [ButtonsModule,CommonModule,KENDO_ICONS],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {

    tabsList: any = headerData;
    @Input() links: Link[] = [];    
    @Input() headerInputs: any;
    @Output() navigateTab = new EventEmitter<any>(); 
    @Input() selectedHeader: string;
    @Input() profile: any;  
    
    userName: string = '';
    userMail: string = '';
    displayName: string = '';    
    endpointURL: string;
   
    userDropdownData = [
      { text: '', value: 'name', url: '' },    
      { text: '', value: 'mail', url: '' },
    ];
  
    constructor(private router:Router,private authService: MsalService, public hsvc: HeaderService) { 
    }
  
    ngOnInit(): void { 
      if(this.profile){
        console.log(this.headerInputs)
        this.userName =  this.headerInputs?.userDetails?.fullName ? this.headerInputs.userDetails?.fullName : this.profile['displayName'];
        this.userDropdownData[0].text = this.userName;
        this.displayName = this.userName.split(',')[0][0] + this.userName.split(',')[1][1]; 
        this.userMail = this.headerInputs?.userDetails?.mail ? this.headerInputs.userDetails?.mail : this.profile['mail'];
        this.userDropdownData[1].text = this.userMail;
        const roles = sessionStorage.getItem('roles');
        if (roles) {
          this.tabsList.headerTabs = headerData.headerTabs;
        } else {
          this.tabsList.headerTabs = headerData.headerTabs.filter(tab => tab.title !== 'Administration');
        }
        console.log("selectedHeader = "+ this.selectedHeader)     
      } 
      analyticsDataLayer.pageInfo.userID = this.userAlias();
    }

    userAlias(): string {
      return this.userMail.replace('@deloitte.com', '');
    }
  
    isDisableTabs(disableTabs, tabs): Boolean {
      let flag: Boolean = false;
      disableTabs?.forEach(element => {
        if (element.toLowerCase() == tabs.toLowerCase()) {
          flag = true;
        }
      });
      return flag;
    }
  
    onDropdownItemClick($event: any) {     
      if ($event.value === 'mail') {
        const mailId = $event.text ? $event.text : this.userMail;
        window.location.href = `mailto:${mailId}`;
      } else if ($event.value === 'signout') {
        this.logout();
      }
    }
  
    logout() {
      this.authService.logoutRedirect({ postLogoutRedirectUri: '/' });
    }  
    
    navigateTo(tab) {      
      this.router.navigateByUrl('/' + tab);
    }
  
    manipulateUserName(name) {
      let matches = name.match(/\b(\w)/g);
      return matches.join("").toUpperCase();
    } 
    
}
